<ng-container *ngLet="data$ | async">
  <button class="btn btn-primary" type="button" (click)="clickBuyAgain()" [disabled]="isBuyAgainDisabled">Buy Again</button>
</ng-container>
